// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"4d5a0ce7","712":"c5d79e46","787":"4b24f717"}[chunkId] + ".chunk.js";
};